module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_sns_04-d8f106c8aa4279f12fa1320cedf97eda.jpg";